import React, { useEffect, useState } from 'react';
import { ScommesseLeafItem, ScommesseLeafItemType } from 'components/scommesseTipo/components/cells/types';
import { hasValue, isTruthy } from 'utility/functions';
import { ItemWithTranslation } from 'types/swagger';
import { ScommesseEsitoTipoBox } from 'components/scommesseEsitoTipoBox';
import { ScommesseTableQuotaSelect } from 'components/scommesseTipo/components/scommesseTableQuotaSelect';
import styles from './Esito.module.scss';
import { useEsitoListSorted, useIsAvvenimento } from 'features/sport/hooks';
import { useTranslation } from 'hooks/useLingUI';
import { SizeInfoAggiuntiva } from 'lib/api/sport/sportScommesseBySlugResponse';
import classNames from 'classnames';

export type DropdownEsitoType = ItemWithTranslation<{ headerSelect?: string }> & {
  type?: ScommesseLeafItemType;
  counter?: number;
  headerBox?: string;
  scommessaKey: string;
  infoAggiuntivaKey: string;
  gtagAction?: () => void;
  size?: SizeInfoAggiuntiva;
};

export const DropdownEsito = ({
  type = ScommesseLeafItem.Esito,
  size,
  counter,
  headerBox,
  headerSelect,
  scommessaKey,
  headerSelectTrKey,
  infoAggiuntivaKey,
  gtagAction,
}: DropdownEsitoType) => {
  const esitoKeyList = useEsitoListSorted(infoAggiuntivaKey);
  const { t } = useTranslation();

  const isAvvenimento = useIsAvvenimento();

  const [esitoKey, selectEsitoKey] = useState<string | undefined>();

  useEffect(() => {
    if (!isTruthy(esitoKeyList?.length)) {
      selectEsitoKey(undefined);
      return;
    }

    if (!esitoKey || !esitoKeyList.includes(esitoKey)) {
      selectEsitoKey(esitoKeyList[0]);
    }
  }, [esitoKey, esitoKeyList]);

  useEffect(() => {
    if (![`${ScommesseLeafItem.Esito}`, `${ScommesseLeafItem.Quota}`].includes(type)) {
      throw new Error(`DropdownEsito: unmanaged option ${type}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isTruthy(esitoKeyList?.length)) {
    return (
      <>
        <ScommesseTableQuotaSelect
          key={`select-${infoAggiuntivaKey}-${esitoKey}-${isAvvenimento}`}
          type={type}
          size={size}
          counter={counter}
          className={classNames(styles.select, { [styles.selectAvvenimento]: isAvvenimento })}
          containerClassName={classNames({ [styles.selectContainerAvvenimento]: isAvvenimento })}
          headerList={[t(headerSelectTrKey, headerSelect)]}
          optionsKeys={esitoKeyList ?? []}
          scommessaKey={scommessaKey}
          hasBilanciata={false} // TODO: PASS PROP BILANCIATA AS PROP
          selectedOptionKey={esitoKey}
          infoAggiuntivaKey={infoAggiuntivaKey}
          onOptionSelected={selectEsitoKey}
        />
        <ScommesseEsitoTipoBox
          key={`box-${infoAggiuntivaKey}-${esitoKey}-${isAvvenimento}`}
          keyEsito={esitoKey}
          showHeader={hasValue(headerBox)}
          className={isAvvenimento ? styles.containerAvvenimento : ''}
          classNameButton={isAvvenimento ? styles.boxAvvenimento : ''}
          scommessaKey={scommessaKey}
          infoAggiuntivaKey={infoAggiuntivaKey}
          gtagAction={gtagAction}
        />
      </>
    );
  }

  return <React.Fragment key={infoAggiuntivaKey} />;
};
